<template>
    <customModal :containerxl="true" @closeModal="$emit('closeModal')">

        <template #title>
            KRI Details
        </template>

        <template #body>
            <div class="modal-content-wrapper">
                <!-- BASIC INFORMATION -->
                <div class="section-block">
                    <h6 class="border-bottom mb-2">
                        Basic Information
                    </h6>
                    <div class="row">
                        <!-- LEFT -->
                        <div class="col-md-7">
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>KRI ID</strong>
                                </div>
                                <div>
                                    {{ data.kriId  }}
                                </div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Risk ID</strong>
                                </div>
                                <div>
                                    {{ data.riskId  }}
                                </div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>CTQ ID</strong>
                                </div>
                                <div>
                                    {{ data.ctqId  }}
                                </div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Risk Indicator</strong>
                                </div>
                                <div>
                                    {{ data.riskIndicator  }}
                                </div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Core / Extended KRI</strong>
                                </div>
                                <div>
                                    {{ data.coreOrExtendedKRI  }}
                                </div>
                            </div>

                            <div class="d-flex py-1">
                                <div class="label-block">
                                    <strong>General / Specific</strong>
                                </div>
                                <div>
                                    {{ data.generalOrSpecific  }}
                                </div>
                            </div>
                        </div>

                        <!-- RIGHT -->
                        <div class="col-md-5">
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Frequency</strong>
                                </div>
                                <div>
                                    {{ data.frequency  }}
                                </div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Type of Risk</strong>
                                </div>
                                <div>
                                    {{ data.typeOfRisk  }}
                                </div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Scorecard</strong>
                                </div>
                                <div>
                                    {{ data.scorecard }}
                                </div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Weighting</strong>
                                </div>
                                <div>
                                    {{ data.weighting  }}
                                </div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Unit</strong>
                                </div>
                                <div>
                                    {{ data.unit  }}
                                </div>
                            </div>

                            <div class="d-flex py-1">
                                <div class="label-block">
                                    <strong>Status</strong>
                                </div>
                                <div>
                                    {{ data.isActive ? "Active" : "Inactive" }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CTQ FACTOR -->
                <div class="section-block mt-3">
                    <h6 class="mb-1">
                        CTQ Factor
                    </h6>
                    <div class="border rounded px-3 py-1 bg-light">
                        {{ data.ctqFactor  }}
                    </div>
                </div>
                <!-- Calculation Logic -->
                <div class="section-block mt-3">
                    <h6 class="mb-1">
                        Calculation Logic
                    </h6>
                    <div class="border rounded px-3 py-1 bg-light">
                        {{ data.kriCalculationLogic  }}
                    </div>
                </div>
                <!-- DISCUSSION DETAILS -->
                <div class="section-block mt-3">
                    <h6 class="mb-1">
                        Discussion Details
                    </h6>
                    <div class="border rounded px-3 py-1 bg-light">
                        {{ data.discussionDetails  }}
                    </div>
                </div>
                <!-- DATA SOURCE / AGGREGATION LEVEL -->
                <div class="section-block mt-3">
                    <div class="row">
                        <div class="col-md-6">
                            <h6 class="mb-1">
                                Data Source
                            </h6>
                            <div class="border rounded px-3 py-1 bg-light">
                                {{ data.dataSource  }}
                            </div>
                        </div>
                        <div class="col-md-6">
                            <h6 class="mb-1">
                                Aggregation Level
                            </h6>
                            <div class="border rounded px-3 py-1 bg-light">
                                {{ data.aggregationLevel  }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- THRESHOLD BASIS -->
                <div class="section-block mt-3">
                    <h6 class="mb-1">
                        Threshold Basis
                    </h6>
                    <div class="border rounded px-3 py-1 bg-light">
                        {{ data.thresholdBasis }}
                    </div>
                </div>
            </div>
        </template>
    </customModal>
</template>

<script src="./KriDetailsModal.js"></script>

<style scoped>

.section-block h6 {
    font-size: .9rem !important;
    font-weight: 600 !important;
    margin-bottom: 4px;
    color: #3d4b63;
}


.label-block {
    min-width: 180px;
}

.table td,
.table th {
    vertical-align: middle;
}

.modal-content-wrapper {
    max-height: 75vh;
    overflow-y: auto;
    padding-right: 4px;
}
</style>